// @mui
import { Card, CardContent, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
//
import Image from '../../components/Image';

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  backgroundColor: theme.palette.info.lighter,
  [theme.breakpoints.up('md')]: {
    height: '100%',
    display: 'flex',
    textAlign: 'left',
    alignItems: 'center',
    justifyContent: 'space-between'
  }
}));

// ----------------------------------------------------------------------

export default function SituationWelcome() {
  return (
    <RootStyle>
      <CardContent
        sx={{
          color: 'grey.800',
          p: { md: 0 },
          pl: { md: 5 }
        }}
      >
        <Typography gutterBottom variant="h4">
          120 Mô Phỏng,
          <br />XE Ô TÔ
          <br />Cập Nhật v2.0.0({new Date().getFullYear()})
        </Typography>

        <Typography variant="body2" sx={{ pb: { xs: 3, xl: 5 }, maxWidth: 480, mx: 'auto' }}>
          Phần mềm thi thử mô phỏng 120 tình huống giao thông online của chúng tôi được phát triển dựa trên phần mềm offline do Tổng Cục Đường Bộ Việt Nam ban hành trước đó.
        </Typography>
      </CardContent>

      <Image alt="" src="/illustrations/police.png"
        sx={{
          p: 3,
          height: 260,
          margin: { xs: 'auto', md: 'inherit' },
          width: 260
        }}
      />
    </RootStyle>
  );
}
